export const mediaObj = {
  smallMobile: "@media screen and (max-width: 320px)",
  mobile: "@media screen and (max-width: 480px)",
  bigMobile: "@media screen and (max-width: 540px)",
  tablet: "@media screen and (max-width: 768px)",
  smallDesktop: "@media screen and (max-width: 1024px)",
  mediumDesktop: "@media screen and (max-width: 1366px)",
  desktop: "@media screen and (max-width: 1520px)",
};
